module.exports = __webpack_public_path__ + "img/trial4-3.30de55a4.png";